/*
 * @Descripttion: 
 * @Author: zcy
 * @Date: 2021-12-27 14:03:12
 * @LastEditors: dong
 * @LastEditTime: 2026-04-28 14:31:43
 */
export default {
  route: {
    home: 'Home',
    case: 'Clients',
    product: 'Products',
    news: 'News',
    videohub: 'Video',
    aboutus: 'About UYU',
    contactus: 'Contact'
  },
  home: {
    telephone: 'Telephone: ',
    email: 'Email: ',
    address: 'Address: ',
    guangzhou_headquarters: 'Guangzhou Headquarters：',
    guangzhou_headquarters_content: 'Rooms 301 and 302, 3rd Floor, Building 1, No. 99 Hanying 1st Road, Huangpu District, Guangzhou',
    zhanjiang_office:'Zhanjiang Office：',
    zhanjiang_office_contentx:'No. 83 Jinkang Middle Road, Mazhang District, Zhanjiang City, Guangdong Province',
    zhejiang_branch:'Zhejiang Branch：',
    zhejiang_branch_contentx:'Jiashan Science and Technology Innovation Center, No. 568 Jinyang East Road, Jiashan County, Jiaxing City, Zhejiang Province'
  },
  case: {
    background: 'Project Background',
    resolved: 'Solve the problem'
  },
  product: {
    title: 'Products & Services',
    product_introduce: 'Digital intelligent hardware',
    platform: 'Uyu Intelligent Aquaculture Platform',
    tutorial: 'Tutorial',
    view_details:'View Details',
    consult_now:'Consult Now',
    more_product:'View more products'
  },
  news: {
    title: 'news',
    releasedate: 'release time',
    year:'year',
    month:'month',
    day:'day'
  },
  videohub: {
    title: 'Video'
  },
  aboutus: {
    company: 'Company Profile',
    technicaladvantage: 'Technical advantages',
    partners: 'Partner'
  },
  contactus: {
    title: 'Contact'
  },
  settings: {
    title: 'Uyu (Guangzhou) Technology Co., Ltd.',
    copyright: '©2018-UYU (Guangzhou) Technology Co., Ltd. All rights reserved',
    recordnumber: 'Guangdong ICP No. 17034685',
    login: 'Log in',
    platform: 'Platform entrance',
    privacy: 'Privacy',
    privacy_title: 'Privacy Policy'
  }
}